common.View.create('canvas.blocks.custom.subPageHeader.Block', {

    onDOMLoad() {
        this.initScrollButton();
    },

    initScrollButton() {
        // Get scroll button and add listener
        this.element.find('.scroll-button').click((e) => {
            // On click find next block and scroll to it
            $([document.documentElement, document.body]).animate({
                scrollTop: this.element.parent().children().eq(1).offset().top + 10
            }, 500);

            // Prevent default link behaviour
            e.preventDefault();
        });
    }
});
